import { render } from "./dropDown.vue?vue&type=template&id=63fb24fc&scoped=true"
import script from "./dropDown.vue?vue&type=script&lang=js"
export * from "./dropDown.vue?vue&type=script&lang=js"

import "./dropDown.vue?vue&type=style&index=0&id=63fb24fc&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63fb24fc"]])

export default __exports__